import React from "react";
import { useParams, useLocation } from "react-router-dom";
import { Container } from "reactstrap";
// FTO UAT Round 2c (2026-08-24): this page family NEVER mounted a
// ToastContainer, so every toast fired by useFtoForm / useCoaForm —
// including "Employee comment is required." on Submit — rendered nowhere.
// The Submit button looked dead when validation (or the server) rejected
// the request. 43 other pages mount their own container; this one now does
// too, covering both the FTO and COA forms.
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { DashboardPageHeader } from "../../Components/Common/DashboardKit";
import FtoForm from "./FtoForm";
import CoaForm from "./CoaForm";

const FtoRequestPage = () => {
    const { id } = useParams();
    const location = useLocation();

    const isCoa = location.pathname.includes("/coa/");
    const recordId = id && id !== "new" ? parseInt(id, 10) : 0;

    const title = isCoa
        ? (recordId ? `COA Request #${recordId}` : "New COA Request")
        : (recordId ? `FTO Request #${recordId}` : "New FTO Request");

    const subtitle = isCoa
        ? (recordId
            ? "Review and edit this Change of Attendance request."
            : "Submit a new Change of Attendance request.")
        : (recordId
            ? "Review and edit this Flexible Time Off request."
            : "Submit a new Flexible Time Off request.");

    return (
        <div className="page-content">
            <Container fluid>
                <DashboardPageHeader
                    icon={isCoa ? "ri-home-gear-line" : "ri-calendar-event-line"}
                    eyebrow="Personal Attendance"
                    title={title}
                    subtitle={subtitle}
                    tone="blue"
                    breadcrumb={[
                        { label: "Dashboards", to: "/" },
                        { label: "Personal Attendance", to: "/personal-attendance" },
                        { label: recordId ? `#${recordId}` : "New" },
                    ]}
                />
                {isCoa
                    ? <CoaForm coaId={recordId} />
                    : <FtoForm ftoId={recordId} />
                }
                <ToastContainer closeButton={false} position="top-right" />
            </Container>
        </div>
    );
};

export default FtoRequestPage;
